import { render, staticRenderFns } from "./MyAllIssue.vue?vue&type=template&id=0fdbe22b&scoped=true&"
import script from "./MyAllIssue.vue?vue&type=script&lang=js&"
export * from "./MyAllIssue.vue?vue&type=script&lang=js&"
import style0 from "./MyAllIssue.vue?vue&type=style&index=0&id=0fdbe22b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdbe22b",
  null
  
)

export default component.exports